import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";
import {PcBox as DefaultPcBox, MobileBox as DefaultMobileBox} from "./header-navbar-container.default.box";

const PcBox = styled(DefaultPcBox)``;

const MobileBox = styled(DefaultMobileBox)`
  border-bottom: none;
`;

export const HeaderNavbarContainerCasino777Box = styledByDevice(PcBox, MobileBox);
